import React from 'react';
import styled from 'styled-components';

import { QuestionCircleOutlined } from '@ant-design/icons';
import Tooltip from 'components/Tooltip';
import HeaderRow from './HeaderRow';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.6em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: center;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const SectionHeader = ({ sectionTitle = '', hideSelect = false, daysOpenPerPeriod = null }) => (
    <HeaderRow style={{ width: '100%' }}>
        <Title style={{ width: '40%' }}>{sectionTitle}</Title>

        <Title style={{ width: '15%' }}>
            Period Total
            {daysOpenPerPeriod && (
                <span style={{ marginLeft: '0.5em' }}>
                    <Tooltip
                        title={
                            daysOpenPerPeriod > 0
                                ? `Total amount for ${daysOpenPerPeriod} days`
                                : `Total amount for the days open in the period`
                        }
                    >
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            )}
        </Title>
        {!hideSelect && (
            <>
                <Title style={{ width: '20%', marginLeft: '1em' }}>% Assigned</Title>
                <Title style={{ width: '15%', marginLeft: '1em' }}>Total</Title>
            </>
        )}
    </HeaderRow>
);
export default SectionHeader;
